<div class="container-fluid mb-5 px-3">
    <div class="mt-3">
        <div class="w-fit">
            <app-back-button url="/permissions" component="Permissions"></app-back-button>
        </div>
    </div>

    <div class="mt-3 d-flex justify-content-between">
        <div class="font-weight-bold">
            <h1>{{ role?.name ?? 'Role' }} Permissions</h1>
        </div>
        <div class="d-flex mt-2 me-1">
            <button mat-raised-button class="action-button"
                [disabled]="loading.value || saving.value || isSuperAdmin || !role"
                (click)="onSaveClick()">
                <mat-spinner *ngIf="saving.value" diameter="18" class="btn-spinner"></mat-spinner>
                <mat-icon *ngIf="!saving.value">save</mat-icon>
                {{ saving.value ? 'Saving...' : 'Save' }}
            </button>
        </div>
    </div>

    <mat-card class="mt-3 p-3">
        <div *ngIf="loading.value" class="d-flex justify-content-center py-4">
            <mat-spinner></mat-spinner>
        </div>

        <div *ngIf="!loading.value && !role" class="empty-state">
            Role not found.
        </div>

        <mat-accordion *ngIf="!loading.value && role" multi>
            <mat-expansion-panel *ngFor="let module of modules">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-checkbox
                            [checked]="isModuleChecked(module.id)"
                            [disabled]="isSuperAdmin"
                            (click)="$event.stopPropagation()"
                            (keydown)="$event.stopPropagation()"
                            (change)="onModuleToggle(module)">
                        </mat-checkbox>
                        <span class="module-name">{{ module.name }}</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="operation-list" *ngIf="getModuleOperations(module.id).length; else noOperations">
                    <mat-checkbox
                        *ngFor="let operation of getModuleOperations(module.id)"
                        class="operation-checkbox"
                        [checked]="isOperationChecked(module, operation.id)"
                        [disabled]="isOperationDisabled(module.id)"
                        (change)="onOperationToggle(module, operation.id)">
                        {{ operation.name }}
                    </mat-checkbox>
                </div>
                <ng-template #noOperations>
                    <div class="empty-state">No operations available for this module.</div>
                </ng-template>
            </mat-expansion-panel>
        </mat-accordion>
    </mat-card>
</div>
